module.exports = __webpack_public_path__ + "img/pro1.da9d7179.jpg";